import { paths } from "../components/paths";
import CommonUtil from "./CommonUtil";

class PathUtil {
  static pathParameter(props, parameterName) {
    const parameter =
      props && props.match && props.match.params
        ? props.match.params[parameterName]
        : undefined;

    return parameter;
  }

  static _constructPathDescriptors(parameters = []) {
    var descriptors = "";

    for (var i = 0; i < parameters.length; i++) {
      const parameter = parameters[i];

      descriptors += `/:${parameter.name}${parameter.optional ? "?" : ""}`;
    }

    return descriptors;
  }

  static constructPathDescriptor(path, parameters = []) {
    return path + this._constructPathDescriptors(parameters);
  }

  static itemPathDescriptor(path, idOptional = true, ...paramsRenamers) {
    path = this._renamePathParameters(path, paramsRenamers);
    return this.constructPathDescriptor(path, [
      { name: "id", optional: idOptional }
    ]);
  }

  static _renamePathParameters(path, paramsRenamers) {
    var renamedPath = path;

    paramsRenamers.forEach(renamer => {
      renamedPath = this._renamePathParameter(
        renamedPath,
        renamer.old,
        renamer.new
      );
    });

    return renamedPath;
  }

  static _renamePathParameter(path, oldName, newName) {
    return path.replace(new RegExp(`:${oldName}`), `:${newName}`);
  }

  static _setParameter(pathParameters, parameter) {
    return parameter.value
      ? pathParameters.replace(
          new RegExp(`:${parameter.name}\\??`),
          parameter.value
        )
      : pathParameters;
  }

  static _removeOptionalParameters(pathParameters) {
    return pathParameters.replace(new RegExp(`/:[a-zA-Z]+\\?`), "");
  }

  static _constructParameters(parameters) {
    var pathParameters = this._constructPathDescriptors(parameters);

    for (var i = 0; i < parameters.length; i++) {
      pathParameters = this._setParameter(pathParameters, parameters[i]);
    }
    pathParameters = this._removeOptionalParameters(pathParameters);

    return pathParameters;
  }

  static constructPath(path, parameters = [], pathPrefix = "") {
    return `${pathPrefix}${path}` + this._constructParameters(parameters);
  }

  static itemsPath(...pathsWithParams) {
    var path = "";

    pathsWithParams.forEach(pathWithParam => {
      const parameters = this._preprocesPathWithParam(pathWithParam);

      path += this.constructPath(
        pathWithParam.path,
        parameters,
        pathWithParam.prefix
      );
    });

    return path;
  }

  static adminItemsPath(...pathsWithParams) {
    if (pathsWithParams && pathsWithParams.length > 0) {
      pathsWithParams[0].prefix = pathsWithParams[0].prefix
        ? pathsWithParams[0].prefix
        : paths.ADMINISTRATION;
    }

    return this.itemsPath(...pathsWithParams);
  }

  static _preprocesPathWithParam(pathWithParam) {
    const configPropNames = ["path", "prefix"];

    const parameters = Object.keys(pathWithParam)
      .filter(key => !configPropNames.includes(key))
      .map(key => {
        return { key: key, value: pathWithParam[key] };
      });

    return parameters;
  }

  static itemPath(path, id) {
    return this.itemsPath({ path: path, id: id });
  }

  static adminItemPath(path, id) {
    return this.adminItemsPath({ path: path, id: id });
  }

  static adminPath(path) {
    return this.jointPath(paths.ADMINISTRATION, path);
  }

  static jointPath(...parts) {
    return CommonUtil.concatStrings(...parts);
  }

  static getIdFromReadController(path) {
    const pathTree = path.split("/");
    return parseInt(pathTree[pathTree.length - 1]);
  }
}

export default PathUtil;
